const getServerSidePages = () => {
  if (typeof window !== 'undefined') {
    try {
      const pages = JSON.parse(window?.getCookie?.('_IL-ssr-pages') || '[]')
      return pages
    } catch (error) {
      return []
    }
  }
  return []
}

export default getServerSidePages
